import { SequenceTypeKey } from '@/types/scheduleExpectation';

const SEQUENCE_TYPE_KEY_LABELS: Record<SequenceTypeKey, string> = {
  future_appointment_request: 'Future Appointment Request',
  oud_starter: 'OUD Starter',
  non_oud_starter: 'Non-OUD Starter'
};

const formatSequenceTypeKey = (typeKey: SequenceTypeKey): string => {
  return SEQUENCE_TYPE_KEY_LABELS[typeKey] || typeKey;
};

export default formatSequenceTypeKey;
